var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.restListHeader.pageBanner.copy
    ? _c(
        "div",
        { staticClass: "outer sticky-wrapper" },
        [
          _c("content-container", [
            _vm.restListHeader.pageBanner.url
              ? _c(
                  "a",
                  {
                    staticClass: "inner",
                    attrs: {
                      href: _vm.restListHeader.pageBanner.url,
                      target: "_blank",
                    },
                  },
                  [
                    _vm.restListHeader.pageBanner.title
                      ? _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.restListHeader.pageBanner.title) +
                              "\n\t\t\t"
                          ),
                        ])
                      : _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n\t\t\t\tHey, " +
                              _vm._s(
                                _vm.restListHeader.pageBanner.titleLocation
                              ) +
                              ".\n\t\t\t"
                          ),
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "copy-wrapper" }, [
                      _vm.restListHeader.pageBanner.copy
                        ? _c("div", { staticClass: "copy" }, [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.restListHeader.pageBanner.copy) +
                                "\n\t\t\t\t"
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "banner-icon-wrapper" },
                        [
                          _c(
                            "icon-base",
                            {
                              attrs: {
                                width: "10px",
                                height: "10px",
                                iconName: "Go To Link",
                                id: "goToPageBannerLink",
                              },
                            },
                            [_c("icon-arrow-right")],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _c("div", { staticClass: "inner" }, [
                  _vm.restListHeader.pageBanner.title
                    ? _c("div", { staticClass: "title" }, [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(_vm.restListHeader.pageBanner.title) +
                            "\n\t\t\t"
                        ),
                      ])
                    : _c("div", { staticClass: "title" }, [
                        _vm._v(
                          "\n\t\t\t\tHey, " +
                            _vm._s(
                              _vm.restListHeader.pageBanner.titleLocation
                            ) +
                            ".\n\t\t\t"
                        ),
                      ]),
                  _vm._v(" "),
                  _vm.restListHeader.pageBanner.copy
                    ? _c("div", { staticClass: "copy" }, [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(_vm.restListHeader.pageBanner.copy) +
                            "\n\t\t\t"
                        ),
                      ])
                    : _vm._e(),
                ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }